<template>
  <div id="app"><router-view /></div>
</template>
<script>
export default {
}
</script>

<style>
@media only screen and (min-width: 1024px){
  html {
    font-size: 70%!important; /* 15.04÷16=94% */
  }
}
body {
  padding-right: 0px!important;
}
</style>
